import React, { Component } from 'react'
import { Alert } from 'loyal-react'
import PropTypes from 'prop-types'

import DetailCreditMileage from '../ConfirmationCreditMileage/AboutCreditMileage/DetailCreditMileage'
import InfoCreditMileage from '../ConfirmationCreditMileage/AboutCreditMileage/InfoCreditMileage'

import '@loyal_template/cart.css'
import '@loyal_template/confirmation.css'

class ConfirmationCreditMileage extends Component {
  state = {
    modalIsOpen: true,
    message: ''
  }

  componentDidMount () {
    if (this.props.orderId) {
      this.props.getOrder(this.props.orderId).then(() => {
        const { vendorId } = this.props.order.vendorOrderModel[0]
        const quickRedemptionEnv =
          process.env.REACT_APP_VENDOR_IDS_QUICK_REDEMPTION
        const quickRedemption =
          quickRedemptionEnv &&
          quickRedemptionEnv
            .split(',')
            .find(id => JSON.parse(id || 0) === JSON.parse(vendorId || 0))
        const redemptionMessage = quickRedemption
          ? 'Concluído! Seu pedido está sendo processado e você receberá seus créditos em alguns instantes.'
          : 'Parabéns! Seu pedido será processado em até 48 horas.'
        this.setState({ message: redemptionMessage })
      })
    }
  }

  handlerCloseSuccess = () => {
    this.setState({ modalIsOpen: false })
  }

  render () {
    if (this.props.order.notFound) {
      this.props.redirectNotFoundPage()
    }
    const { order } = this.props
    const props =
      order.vendorOrderModel && order.vendorOrderModel[0].items
        ? {
          ...order,
          ...order.vendorOrderModel[0].items[0],
          vendorName: order.vendorOrderModel[0].vendorName,
          itemId: order.vendorOrderModel[0].items[0].id,
          orderId: order.vendorOrderModel[0].orderId
        }
        : {}
    return (
      <div className='container-cart container py-5 '>
        <div className='row'>
          {this.state.modalIsOpen && this.state.message ? (
            <Alert
              isError={false}
              title={this.state.message}
              description='Veja abaixo o resumo do seu pedido.'
              className={`mb-4`}
              onClose={() => this.handlerCloseSuccess()}
            />
          ) : (
            ''
          )}
        </div>
        <div className='row'>
          <div className='cart-side col-12 col-md-8 pl-0 pr-2'>
            <div className='row border-ui-3 radius bg-white'>
              <div className='col-12 py-3 px-3 mx-0  border-color-ui-3 border-bottom'>
                <h3 className='color-title txt-font-body txt-uppercase txt-body'>
                  Resumo do pedido
                </h3>
              </div>
              <div className='cart-products col-12 mx-0'>
                <DetailCreditMileage {...props} />
              </div>
            </div>
          </div>
          <InfoCreditMileage {...props} />
        </div>
      </div>
    )
  }
}

ConfirmationCreditMileage.propTypes = {
  order: PropTypes.object,
  orderId: PropTypes.number,
  getOrder: PropTypes.func,
  redirectNotFoundPage: PropTypes.func,
  handlerCloseSuccess: PropTypes.func
}

export default ConfirmationCreditMileage



// WEBPACK FOOTER //
// ./src/features/Services/ConfirmationCreditMileage/ConfirmationCreditMileage.js